import { render, staticRenderFns } from "./StartupRegistration.vue?vue&type=template&id=da236bfe&scoped=true"
import script from "./StartupRegistration.vue?vue&type=script&lang=js"
export * from "./StartupRegistration.vue?vue&type=script&lang=js"
import style0 from "./StartupRegistration.vue?vue&type=style&index=0&id=da236bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da236bfe",
  null
  
)

export default component.exports